module.exports = __webpack_public_path__ + "static/img/ikona_galeria-ON.75a5f670.png";